import { render, staticRenderFns } from "./EInvoiceVatTables.vue?vue&type=template&id=3520d673&scoped=true"
import script from "./EInvoiceVatTables.vue?vue&type=script&lang=js"
export * from "./EInvoiceVatTables.vue?vue&type=script&lang=js"
import style0 from "./EInvoiceVatTables.vue?vue&type=style&index=0&id=3520d673&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520d673",
  null
  
)

export default component.exports